import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import transactionDataService from "services/transaction";
import _set from "lodash/set";

// Async thunk for get Review Transactions
export const getTransactionsAsync = createAsyncThunk(
  "transaction/get",
  async ({ queryParams }, { rejectWithValue }) => {
    try {
      const res = await transactionDataService.get(queryParams);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Async thunk for get Review Transactions
export const getTransactionUnderReviewAsync = createAsyncThunk(
  "transaction/:id/review",
  async ({ trxId, queryParams = {} }, { rejectWithValue }) => {
    try {
      const res = await transactionDataService.getTransactionUnderReview(
        trxId,
        queryParams
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Async thunk for updating a transaction
export const updateTransaction = createAsyncThunk(
  "transaction/:id",
  async ({ trxId, data, queryParams = {} }, { rejectWithValue }) => {
    try {
      const res = await transactionDataService.updateTransaction(
        trxId,
        data,
        queryParams
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Async thunk for updating directors
export const getTransactionForChangesSignatureAsync = createAsyncThunk(
  "transaction/:id/changes-signature",
  async ({ trxId, queryParams = {} }, { rejectWithValue }) => {
    try {
      const res =
        await transactionDataService.getTransactionForChangesSignature(
          trxId,
          queryParams
        );
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Async thunk for get Review Transactions
export const updatedirectorsWhoHaveApproved = createAsyncThunk(
  "transaction/:id/directors-who-have-reviewed",
  async ({ trxId }, { rejectWithValue }) => {
    try {
      const res = await transactionDataService.updatedirectorsWhoHaveApproved(
        trxId
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Async thunk for get Review Transactions
export const getTransactionsForReviewAsync = createAsyncThunk(
  "transaction/getTransactionsToReview",
  async ({ queryParams }, { rejectWithValue }) => {
    try {
      const res = await transactionDataService.getTransactionsToReview(
        queryParams
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Async thunk for get getting transactions in signature
export const getTransactionsForSignatureAsync = createAsyncThunk(
  "transaction/getTransactionsForSignatureAsync",
  async ({ queryParams }, { rejectWithValue }) => {
    try {
      const res = await transactionDataService.getTransactionsForSignature(
        queryParams
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Async thunk for get transactions for corrections
export const getTransactionsForCorrectionsAsync = createAsyncThunk(
  "transaction/getTransactionsForCorrectionsAsync",
  async ({ queryParams }, { rejectWithValue }) => {
    try {
      const res = await transactionDataService.getTransactionsForCorrections(
        queryParams
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTransactionListAsync = createAsyncThunk(
  "transaction/getTransactionListAsync",
  async (queryParams, thunkAPI) => {
    try {
      const res = await transactionDataService.list(queryParams);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  transaction: {
    items: [],
    totalCount: 0,
  },
  getTransaction: {
    status: "idle",
    error: false,
  },

  transactionUnderReview: {
    items: [],
    totalCount: 0,
  },
  getTransactionUnderReview: {
    status: "idle",
    error: false,
  },

  transactionList: {
    items: [],
    totalCount: 0,
  },
  getTransactionList: {
    status: "idle",
    error: false,
  },

  transactionsForReview: {
    items: [],
    totalCount: 0,
  },
  getTransactionsForReview: {
    status: "idle",
    error: false,
  },

  transactionsForCorrections: {
    items: [],
    totalCount: 0,
  },
  getTransactionsForCorrections: {
    status: "idle",
    error: false,
  },

  transactionsForSignature: {
    items: [],
    totalCount: 0,
  },
  getTransactionsForSignature: {
    status: "idle",
    error: false,
  },
};

const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    updateTransactionUnderReview: (
      state,
      { payload: { newNestedField, updateEffectPath } }
    ) => {
      return _set(state, updateEffectPath.split(".").slice(1), newNestedField);
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      /** getTransactionsAsync */
      .addCase(getTransactionsAsync.pending, (state) => {
        state.getTransaction.status = "loading";
        state.getTransaction.error = null;
      })
      .addCase(getTransactionsAsync.fulfilled, (state, action) => {
        state.getTransaction.status = "succeeded";
        state.transaction.items = action.payload.items;
        state.transaction.totalCount = action.payload.totalCount;
      })
      .addCase(getTransactionsAsync.rejected, (state, action) => {
        state.getTransaction.status = "failed";
        state.getTransaction.error = action?.payload?.messageText;
      })

      /** getTransactionUnderReviewAsync */
      .addCase(getTransactionUnderReviewAsync.pending, (state) => {
        state.getTransactionUnderReview.status = "loading";
        state.getTransactionUnderReview.error = null;
      })
      .addCase(getTransactionUnderReviewAsync.fulfilled, (state, action) => {
        state.getTransactionUnderReview.status = "succeeded";
        state.transactionUnderReview.items = action.payload.items;
        state.transactionUnderReview.totalCount = action.payload.totalCount;
      })
      .addCase(getTransactionUnderReviewAsync.rejected, (state, action) => {
        state.getTransactionUnderReview.status = "failed";
        state.getTransactionUnderReview.error = action?.payload?.messageText;
      })

      /** getTransactionForChangesSignatureAsync */
      .addCase(getTransactionForChangesSignatureAsync.pending, (state) => {
        state.getTransactionUnderReview.status = "loading";
        state.getTransactionUnderReview.error = null;
      })
      .addCase(
        getTransactionForChangesSignatureAsync.fulfilled,
        (state, action) => {
          state.getTransactionUnderReview.status = "succeeded";
          state.transactionUnderReview.items = action.payload.items;
          state.transactionUnderReview.totalCount = action.payload.totalCount;
        }
      )
      .addCase(
        getTransactionForChangesSignatureAsync.rejected,
        (state, action) => {
          state.getTransactionUnderReview.status = "failed";
          state.getTransactionUnderReview.error = action?.payload?.messageText;
        }
      )

      /** getTransactionsForReviewAsync */
      .addCase(getTransactionsForReviewAsync.pending, (state) => {
        state.getTransactionsForReview.status = "loading";
        state.getTransactionsForReview.error = null;
      })
      .addCase(getTransactionsForReviewAsync.fulfilled, (state, action) => {
        state.getTransactionsForReview.status = "succeeded";
        state.transactionsForReview.items = action.payload.items;
        state.transactionsForReview.totalCount = action.payload.totalCount;
      })
      .addCase(getTransactionsForReviewAsync.rejected, (state, action) => {
        state.getTransactionsForReview.status = "failed";
        state.getTransactionsForReview.error = action?.payload?.messageText;
      })

      /** getTransactionsForCorrectionsAsync */
      .addCase(getTransactionsForCorrectionsAsync.pending, (state) => {
        state.getTransactionsForCorrections.status = "loading";
        state.getTransactionsForCorrections.error = null;
      })
      .addCase(
        getTransactionsForCorrectionsAsync.fulfilled,
        (state, action) => {
          state.getTransactionsForCorrections.status = "succeeded";
          state.transactionsForCorrections.items = action.payload.items;
          state.transactionsForCorrections.totalCount =
            action.payload.totalCount;
        }
      )
      .addCase(getTransactionsForCorrectionsAsync.rejected, (state, action) => {
        state.getTransactionsForCorrections.status = "failed";
        state.getTransactionsForCorrections.error =
          action?.payload?.messageText;
      })

      /** getTransactionsForSignatureAsync */
      .addCase(getTransactionsForSignatureAsync.pending, (state) => {
        state.getTransactionsForSignature.status = "loading";
        state.getTransactionsForSignature.error = null;
      })
      .addCase(getTransactionsForSignatureAsync.fulfilled, (state, action) => {
        state.getTransactionsForSignature.status = "succeeded";
        state.transactionsForSignature.items = action.payload.items;
        state.transactionsForSignature.totalCount = action.payload.totalCount;
      })
      .addCase(getTransactionsForSignatureAsync.rejected, (state, action) => {
        state.getTransactionsForSignature.status = "failed";
        state.getTransactionsForSignature.error = action?.payload?.messageText;
      })

      /** getTransactionListAsync */
      .addCase(getTransactionListAsync.pending, (state) => {
        state.getTransactionList.status = "loading";
        state.getTransactionList.error = null;
      })
      .addCase(getTransactionListAsync.fulfilled, (state, action) => {
        state.getTransactionList.status = "succeeded";
        state.transactionList.items = action.payload.items;
        state.transactionList.totalCount = action.payload.totalCount;
      })
      .addCase(getTransactionListAsync.rejected, (state, action) => {
        state.getTransactionList.status = "failed";
        state.getTransactionList.error = action?.payload?.messageText;
      });
  },
});

export const { reset, updateTransactionUnderReview } = transactionSlice.actions;

export default transactionSlice.reducer;
